// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coursesDropDown
{
    width: 100%;
    height: auto;
     display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 2%;
    
}
.coursesOption
{
    width: 30%;
   
 
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    resize: vertical;

}
.progress
{
    background-color: #faf1e3;
    padding: 3%;
    /* width:50% ; */
    /* margin: 3% 0% 0%  25%; */
    
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  
    border-radius: 2vh;
    box-shadow: 0 3px 5px 0 rgba(100, 96, 96, 0.3); /* This creates a shadow effect */

}
.student-progress
{
    background-color: #faf1e3;
    padding: 3%;
    /* width:50% ; */
    /* margin: 3% 0% 0%  25%; */
    
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  
    border-radius: 2vh;
    box-shadow: 0 3px 5px 0 rgba(100, 96, 96, 0.3); /* This creates a shadow effect */
    background-color: rgb(250, 241, 227);
    border-radius: 10px;
    box-shadow: rgb(170, 170, 170) 2px 2px 4px 0px;
    opacity: 1;

}

.progressSection {
    display: flex;
    flex-direction: column;
    /* align-items: normal; */
    width: 100%;
  }
  .processSectionCol{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .progressGrid {
    /* display: grid; */
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    /* grid-template-columns: auto auto; */
    column-gap: 20px;
    row-gap: 10px; 
  }
  .studentProgressSection {
    display: flex;
    flex-direction: column;
    width: 100%;
    /* align-items: normal; */
  }
  
  .studentProgressGrid {
    display: flex;
    /* display: grid; */

    /* grid-template-columns: auto auto; */
    flex-direction: row;
    justify-content: space-around;
    column-gap: 20px;
    row-gap: 10px; 
  }
  
  .progressGrid label {
    font-size: 3vh;
    color: #da831e;
    height: 10vh;
    display: flex;
    align-items: center;
  }
  
  .MyProgressRemarks {
    display: flex;
    align-items: center;
    padding: 5px 0; 
  }
  
.progressHead
{
    width:75%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #da831e;
}
.progressNumbers
{
    width: 50%;
    display: flex;   
  
}
.MyProgressRemarks
{
    width: 10vh;
    height: 10vh;
    border-radius: 10vh;
    border: 2px solid white;
    text-align: center;
    background-color:#faf1e3;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2%;
    box-shadow: 0px 0px 3px 3px rgba(100, 96, 96, 0.3); /* This creates a shadow effect */

}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/MyProgress.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,YAAY;KACX,aAAa;IACd,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;;AAEnB;AACA;;IAEI,UAAU;;;IAGV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;;AAEpB;AACA;;IAEI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;;IAE3B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,kBAAkB;IAClB,8CAA8C,EAAE,iCAAiC;;AAErF;AACA;;IAEI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;;IAE3B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,kBAAkB;IAClB,8CAA8C,EAAE,iCAAiC;IACjF,oCAAoC;IACpC,mBAAmB;IACnB,8CAA8C;IAC9C,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,sCAAsC;IACtC,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;;IAEnB,sCAAsC;IACtC,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;AAEF;;IAEI,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;AACA;;IAEI,UAAU;IACV,aAAa;;AAEjB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,kDAAkD,EAAE,iCAAiC;;AAEzF","sourcesContent":[".coursesDropDown\n{\n    width: 100%;\n    height: auto;\n     display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding-top: 2%;\n    \n}\n.coursesOption\n{\n    width: 30%;\n   \n \n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n    resize: vertical;\n\n}\n.progress\n{\n    background-color: #faf1e3;\n    padding: 3%;\n    /* width:50% ; */\n    /* margin: 3% 0% 0%  25%; */\n    \n    height: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  \n    border-radius: 2vh;\n    box-shadow: 0 3px 5px 0 rgba(100, 96, 96, 0.3); /* This creates a shadow effect */\n\n}\n.student-progress\n{\n    background-color: #faf1e3;\n    padding: 3%;\n    /* width:50% ; */\n    /* margin: 3% 0% 0%  25%; */\n    \n    height: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  \n    border-radius: 2vh;\n    box-shadow: 0 3px 5px 0 rgba(100, 96, 96, 0.3); /* This creates a shadow effect */\n    background-color: rgb(250, 241, 227);\n    border-radius: 10px;\n    box-shadow: rgb(170, 170, 170) 2px 2px 4px 0px;\n    opacity: 1;\n\n}\n\n.progressSection {\n    display: flex;\n    flex-direction: column;\n    /* align-items: normal; */\n    width: 100%;\n  }\n  .processSectionCol{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .progressGrid {\n    /* display: grid; */\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    /* grid-template-columns: auto auto; */\n    column-gap: 20px;\n    row-gap: 10px; \n  }\n  .studentProgressSection {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    /* align-items: normal; */\n  }\n  \n  .studentProgressGrid {\n    display: flex;\n    /* display: grid; */\n\n    /* grid-template-columns: auto auto; */\n    flex-direction: row;\n    justify-content: space-around;\n    column-gap: 20px;\n    row-gap: 10px; \n  }\n  \n  .progressGrid label {\n    font-size: 3vh;\n    color: #da831e;\n    height: 10vh;\n    display: flex;\n    align-items: center;\n  }\n  \n  .MyProgressRemarks {\n    display: flex;\n    align-items: center;\n    padding: 5px 0; \n  }\n  \n.progressHead\n{\n    width:75%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    color: #da831e;\n}\n.progressNumbers\n{\n    width: 50%;\n    display: flex;   \n  \n}\n.MyProgressRemarks\n{\n    width: 10vh;\n    height: 10vh;\n    border-radius: 10vh;\n    border: 2px solid white;\n    text-align: center;\n    background-color:#faf1e3;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 2%;\n    box-shadow: 0px 0px 3px 3px rgba(100, 96, 96, 0.3); /* This creates a shadow effect */\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
